/** @prettier */
import React, { ReactNode } from "react";
import { useHistory } from "react-router";
import { Button } from "react-bootstrap";

type LinkButtonProps = { title: string; to: string; children: ReactNode };
/**
 * Bootstrap button that functions like a react-router <Link> component
 */
export const LinkButton = ({ title, to, children }: LinkButtonProps) => {
    const history = useHistory();
    return (
        <Button bsStyle="link" title={title} onClick={() => history.push(to)}>
            {children}
        </Button>
    );
};
